import bTable from './table';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bTable: bTable
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/index.js
// module id = 445
// module chunks = 0